


































































































import Vue from 'vue';
import {LoadedSubmission} from '@/store/submissions';
import ComputerEmulator from '@/components/ComputerEmulator.vue';
import FavoriteStar from '@/components/FavoriteStar.vue';
import Favorite from '@/components/types/Favorite';

enum State {
    Loading = 'Loading',
    Loaded = 'Loaded',
    Error = 'Error',
}

export default Vue.extend({
    name: 'play',

    components: { ComputerEmulator, FavoriteStar },

    data() : {
        state: State,
        loaded?: LoadedSubmission,
        errorMessage?: string,
    } {
        return {
            state: State.Loading,
        };
    },

    methods: {
        async favorited(): Promise<void> {
            if (!this.loaded!.favorite)
                await this.$store.dispatch('submissions/favorite', this.$route.params.id);
            else
                await this.$store.dispatch('submissions/unfavorite', this.$route.params.id);
        },
    },

    async mounted(): Promise<void> {
        try {
            await this.$store.dispatch('submissions/load', this.$route.params.id);
            this.loaded = this.$store.state.submissions.loaded;
            this.state = State.Loaded;
        } catch (e) {
            console.error(e);
            this.errorMessage = e.message;
            this.state = State.Error;
        }
    },
});
